import {Express} from "express";
import { MemberInterface } from "../Members/Members.Interface";

export interface APIRequest extends Express.Request {
  user:MemberInterface
}


export interface APIValidateErrorJSON {
  message: 'Validation failed'
  details: { [name: string]: unknown }
}

export interface APISuccessMessage {
  status: 'success'
  message?: string
}

// export class APIError extends Error {
//   statusCode: number
//   status: number
//   isAPIError: boolean = true
//   constructor(name: string, statusCode: number, message?: string) {
//     super(message)
//     this.name = name
//     this.statusCode = statusCode
//     this.status = statusCode
//     if (typeof message === 'string') {
//       this.message = message
//     }
//   }
// }
export function CreateSuccessMessage(message?: string): APISuccessMessage {
  if (message) {
    return { status: 'success', message: message }
  }
  return { status: 'success' }
}



export enum APIErrorNames {
  INVALID_TOKEN_VERIFY = 'Invalid Token - Verify',
  INVALID_TOKEN_EXPIRED = 'Invalid Token - Expired',
}

// Note: Our custom error extends from Error, so we can throw this error as an exception.
export class APIError extends Error {
  override message!: string;
  status!: number;
  additionalInfo!: any;
  isAPIError: boolean = true

  constructor(message: string, status: number = 500, additionalInfo: any = undefined) {
      super(message);
      this.message = message;
      this.status = status;
      this.additionalInfo = additionalInfo;
  }
};
export class ClientError extends APIError { constructor(message: string) {  super(message, 400); }}
export class UnauthorizedError extends APIError { constructor(message: string) {  super(message, 401); }}
export class ForbiddenError extends APIError { constructor(message: string) {  super(message, 403); }}
export class NotFoundError extends APIError { constructor(message: string) {  super(message, 404); }}


